import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21184ae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { style: {"font-size":"10pt"} }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_4 = { class: "controlBar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<option disabled value=\"0\" data-v-21184ae8>Separator</option><option value=\"1\" data-v-21184ae8>&gt; (default)</option><option value=\"2\" data-v-21184ae8>+</option><option value=\"3\" data-v-21184ae8>-</option><option value=\"4\" data-v-21184ae8>~</option>", 5)
const _hoisted_11 = [
  _hoisted_6
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltiptext" }, "Click to collapse", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, "List of emotes", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltiptext" }, "Click to expand", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "ac-container" }
const _hoisted_18 = { class: "form-check form-check-inline" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "cbxLangEng"
}, "eng", -1))
const _hoisted_20 = { class: "form-check form-check-inline" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "cbxLangGer"
}, "ger", -1))
const _hoisted_22 = {
  key: 0,
  class: "ac-filtered-items"
}
const _hoisted_23 = ["onClick", "onMouseover"]
const _hoisted_24 = { style: {"font-size":"8pt"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "table-responsive" }
const _hoisted_28 = { class: "table table-dark table-striped" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-clipboard",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" })
], -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "green",
  class: "bi bi-check",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" })
], -1))
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, " Hello, today is " + _toDisplayString(_ctx.currentMouvDate()) + ", " + _toDisplayString(_ctx.currentElonDate()) + ", " + _toDisplayString(_ctx.currentCantDate()), 1)
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("textarea", {
        id: "chatContent",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chatContent) = $event)),
        ref: "chatEdit",
        placeholder: "Insert something in me OwO",
        cols: "50",
        rows: "10",
        class: "form-control",
        onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
      }, null, 544), [
        [_vModelText, _ctx.chatContent]
      ]),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-danger",
            style: {"margin-top":"4px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteAreaInput && _ctx.deleteAreaInput(...args)))
          }, [
            _hoisted_5,
            _createTextVNode(" Delete ")
          ])
        ]),
        _createElementVNode("li", null, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm",
            style: {"margin-top":"4px","width":"110px","height":"38px"},
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected) = $event)),
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
          }, _hoisted_11, 544), [
            [_vModelSelect, _ctx.selected]
          ])
        ]),
        _createElementVNode("li", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            placeholder: "Limit",
            value: "197",
            min: "3",
            class: "form-control form-control-sm",
            style: {"margin-top":"4px","width":"110px","height":"38px"},
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            title: "This field determines the number of characters that can appear in a message. Can be set as required.\r\n            - GW2-Mode: 197\r\n            - Discord-Mode: 1998",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.charLimitInput) = $event)),
            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
          }, null, 544), [
            [_vModelText, _ctx.charLimitInput]
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            style: {"margin-top":"4px"},
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.insertTextAtCursor(' /e ')))
          }, "Start emote"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            style: {"margin-top":"4px"},
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.insertTextAtCursor(' ## ')))
          }, "End emote")
        ]),
        _createElementVNode("li", null, [
          (_ctx.listCollapsed)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 0,
                id: "emoteListID",
                class: "list-group",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeEmoteList && _ctx.changeEmoteList(...args)))
              }, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emotes, (emote, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "list-group-item py-0",
                    onClick: ($event: any) => (_ctx.insertTextAtCursor(' ' + emote + ' '))
                  }, _toDisplayString(emote), 9, _hoisted_13))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("ul", {
                key: 1,
                id: "emoteID",
                class: "list-group",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.changeEmoteList && _ctx.changeEmoteList(...args)))
              }, _hoisted_16))
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", null, "total characters: " + _toDisplayString(_ctx.totalCharacter), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _withDirectives(_createElementVNode("input", {
        class: "form-group",
        type: "search",
        placeholder: "Search for chatlink",
        title: "Input is case sensitive!",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchInput) = $event)),
        onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
        onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.inputChanged && _ctx.inputChanged(...args))),
        onFocus: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
        onKeyup: [
          _cache[15] || (_cache[15] = _withKeys(
//@ts-ignore
(...args) => (_ctx.escape && _ctx.escape(...args)), ["esc"])),
          _cache[16] || (_cache[16] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)), ["enter"]))
        ],
        onKeydown: [
          _cache[17] || (_cache[17] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)), ["tab"])),
          _cache[18] || (_cache[18] = _withKeys(
//@ts-ignore
(...args) => (_ctx.up && _ctx.up(...args)), ["up"])),
          _cache[19] || (_cache[19] = _withKeys(
//@ts-ignore
(...args) => (_ctx.down && _ctx.down(...args)), ["down"]))
        ]
      }, null, 544), [
        [_vModelText, _ctx.searchInput]
      ]),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          id: "cbxLangEng",
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.cbxLangEng) = $event)),
          "true-value": "true",
          "false-value": "false",
          checked: "",
          onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.updateLanguage && _ctx.updateLanguage(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.cbxLangEng]
        ]),
        _hoisted_19
      ]),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          id: "cbxLangGer",
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.cbxLangGer) = $event)),
          "true-value": "true",
          "false-value": "false",
          onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.updateLanguage && _ctx.updateLanguage(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.cbxLangGer]
        ]),
        _hoisted_21
      ]),
      (_ctx.showItems)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["ac-filtered-item", { 'ac-filtered-item__hovered': index === _ctx.cursor }]),
                key: index,
                onClick: ($event: any) => (_ctx.selectItem(item)),
                onMouseover: ($event: any) => (_ctx.cursor = index)
              }, [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(item.name) + ", ", 1),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(item.chat_link), 1)
                ])
              ], 42, _hoisted_23))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_25,
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("table", _hoisted_28, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.singleMessage, (msg) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: msg.text
            }, [
              _createElementVNode("td", null, _toDisplayString(msg.text), 1),
              _createElementVNode("td", null, [
                (msg.text)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: ($event: any) => (_ctx.onCopy(msg)),
                      class: "btn btn-outline-info"
                    }, [
                      _hoisted_30,
                      _createTextVNode(" Copy ")
                    ], 8, _hoisted_29))
                  : _createCommentVNode("", true)
              ]),
              (msg.copied)
                ? (_openBlock(), _createElementBlock("td", _hoisted_31, _hoisted_33))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}